import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {MapTopics, SocketTopics} from "../../../constants/enums"
// import useSocket from "use-socket.io-client";
import io from "socket.io-client";

export default ( socket: ISocket) => {
  // const socket: SocketIOClient.Socket = io(process.env.REACT_APP_GPS_SOCKET);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      // if (socket) {
      //   socket.disconnect();
      // }
    };
  }, []);

  // handle data in socket

  // const handleData = (response: any) => {
  //   const gps = response.data.gps;
  //   if (!gps) {
  //     return;
  //   }
  //   console.log("gps live added here", gps);
  //   dispatch({
  //     type: "ADD_GPS",
  //     payload: { response: { meta_data: { gps: [gps] } }, live: true },
  //   });
  //   // dispatch gps data
  // };

  const connectSocket = () => {
    // socket.connect();
    // socket.on("connect", () => {
    //   console.log("socket connected");
    // });
    // socket.on("error", () => {
    //   console.log("socket error");
    // });
    // // Handle incoming gps data
    // socket.on("gpsDetails", handleData);
  };

  const subscribeToImeis = (imeis: any) => {
    console.log("subscribed imei function", imeis);
    imeis.map((topic)=>{
      console.log('subscribe to topic', topic);
      socket.subscribeToEvent(SocketTopics.SubscribePageTopics,  topic);
    })
  };

  const unsubscribeToImeis = (imeis: any) => {
    console.log("un subscribed imei function", imeis);
    imeis.map((topic)=>{
      console.log('un subscribe to topic', topic);
      socket.unSubscribeToEvent(SocketTopics.UnSubscribePageTopics,  topic);
    })

  };

  return {
    connectSocket,
    subscribeToImeis,
    unsubscribeToImeis,
  };
};
